<template>
    <div class="vliveInfo bgc box-shadow">
        <div class="padding-20 info-box">
            <div class="step-list">
                <div class="step" :class="[item.streamstatus==0?'is-active':(item.streamstatus==1?'sel':(item.streamstatus==2?'sel':''))]">
                    <div class="title">1 未开始</div>
                    <div class="pentagon">
                        <span></span>
                    </div>
                </div>
                <div class="step" :class="[item.streamstatus==1?'is-active':(item.streamstatus==10?'sel':'')]" v-if="item.streamstatus==1">
                    <div class="title">2 直播中</div>
                    <div class="pentagon">
                        <span></span>
                    </div>
                </div>
                <div class="step" :class="[item.streamstatus==2?'is-active':(item.streamstatus==10?'sel':'')]" v-else>
                    <div class="title">2 直播中</div>
                    <div class="pentagon">
                        <span></span>
                    </div>
                </div>
                <div class="step" :class="[item.streamstatus==10?'is-active':'']">
                    <div class="title">3 直播结束</div>
                </div>
            </div>
            <div class="step-content">
                <div class="step-content-1" v-if="item.streamstatus==0">
                    <div class="plug-flow-list">
                        <div v-show="visible" class="box">
                            <div class="plug-flow-info">
                                <span class="name">推流服务器（URL）：</span>
                                <span class="value"><input type="text" v-model="item.fmsurl" readonly></span>
                                <el-button class="btn" type="text" size="small" v-clipboard:copy="item.fmsurl" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                            </div>
                            <div class="plug-flow-info">
                                <span class="name">推流串流密码：</span>
                                <span class="value"><input type="text" v-model="item.streamCluster" readonly></span>
                                <el-button class="btn" type="text" size="small" v-clipboard:copy="item.streamCluster" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                            </div>
                        </div>
                    </div>
                    <div class="plug-flow-status">
                        <div class="status">尚未进行推流</div>
                    </div>
                </div>
                <div class="step-content-2" v-if="item.streamstatus==1">
                    <div class="plug-flow-list">
                        <div v-show="visible" class="box">
                            <div class="plug-flow-info">
                                <span class="name">推流服务器（URL）：</span>
                                <span class="value"><input type="text" v-model="item.fmsurl" readonly></span>
                                <el-button class="btn" type="text" size="small" v-clipboard:copy="item.fmsurl" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                            </div>
                            <div class="plug-flow-info">
                                <span class="name">推流串流密码：</span>
                                <span class="value"><input type="text" v-model="item.streamCluster" readonly></span>
                                <el-button class="btn" type="text" size="small" v-clipboard:copy="item.streamCluster" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                            </div>
                        </div>
                        <div class="slide-btn" @click="visible=!visible"><span :class="[visible?'el-icon-d-arrow-left':'el-icon-d-arrow-right']"></span></div>
                        <div class="box" v-show="!visible">
                            <div class="plug-flow-info abnormal">
                            <span class="name">
                                <div class="tc-grey">推流状态</div>
                                <div>正在推流，测速中……</div>
                            </span>
                                <span class="value"><i class="icon icon_vlive"></i></span>
                                <span class="btn"></span>
                            </div>
                        </div>
                    </div>
                    <div class="plug-flow-status">
                        <el-button type="danger" @click="handleEnd">结束直播</el-button>
                    </div>
                </div>
                <div class="step-content-2" v-if="item.streamstatus==2">
                    <div class="plug-flow-list">
                        <div v-show="visible" class="box">
                            <div class="plug-flow-info">
                                <span class="name">推流服务器（URL）：</span>
                                <span class="value"><input type="text" v-model="item.fmsurl" readonly></span>
                                <el-button class="btn" type="text" size="small" v-clipboard:copy="item.fmsurl" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                            </div>
                            <div class="plug-flow-info">
                                <span class="name">推流串流密码：</span>
                                <span class="value"><input type="text" v-model="item.streamCluster" readonly></span>
                                <el-button class="btn" type="text" size="small" v-clipboard:copy="item.streamCluster" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                            </div>
                        </div>
                        <div class="slide-btn" @click="visible=!visible"><span :class="[visible?'el-icon-d-arrow-left':'el-icon-d-arrow-right']"></span></div>
                        <div v-show="!visible" class="box">
                            <div class="plug-flow-info normal">
                                <span class="name">直播信号中断</span>
                                <span class="value"><i class="icon icon_danger"></i>请检查直播设备是否正常工作！</span>
                                <span class="btn"></span>
                            </div>
                        </div>
                    </div>
                    <div class="plug-flow-status">
                        <el-button type="danger" @click="handleEnd">结束直播</el-button>
                    </div>
                </div>
                <div class="step-content-3" v-if="item.streamstatus==10">
                    直播已结束
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getVliveAdressInfo, updateVliveEndStatus, getVliveStreamStatus} from 'api/vliveV2Api'
    import {mapGetters, mapActions} from 'vuex'
    import {urlToQRCode} from 'common/js/tools'
    import {vliveMsg} from 'api/message'
    export default {
        name: 'LiveInfo',
        data() {
            return {
                type: 1,
                visible: true,
                url: 'http',
                item: {
                    assetinnerid: this.$route.query.assetinnerid ? this.$route.query.assetinnerid : '', // 直播id
                },
                wxQrCode: '',
                timer: null
            }
        },
        mounted() {
            this._getView()
            let _this = this
            this.timer = setInterval(() => {
                _this._getVliveStatus()
            }, 10000)
        },
        methods: {
            openPage(url) {
                window.open(url)
            },
            _getVliveStatus() {
                getVliveStreamStatus({
                    data: {
                        liveid: this.item.assetinnerid
                    },
                    success: data => {
                        if (this.item.streamstatus === 10) {
                            clearInterval(this.timer)
                        }
                        this.item.streamstatus = data.data.streamstatus
                        this.setLoading(false)
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            handleEnd() {
                this.$prompt('<span class="tc-grey">' + vliveMsg.endVlive.msg + '</span>', vliveMsg.endVlive.title, {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: vliveMsg.endVlive.confirmText,
                    cancelButtonText: vliveMsg.endVlive.cancelText
                }).then(({value}) => {
                    updateVliveEndStatus({
                        data: {
                            liveid: this.item.assetinnerid,
                            verification:value
                        },
                        success: data => {
                            this.item.streamstatus = 10
                            clearInterval(this.timer)
                            this.setLoading(false)
                        },
                        error: data => {
                            this.setLoading(false)
                            this.$message.error(data.msg)
                        }
                    })
                }).catch(() => {})
            },
            onCopy(e) {
                this.$message({
                    message: '复制成功',
                    type: 'success'
                })
            },
            onError(e) {
                alert('失败')
            },
            _getView() {
                this.setLoading(true)
                getVliveAdressInfo({
                    data: {
                        liveid: this.item.assetinnerid
                    },
                    success: data => {
                        this.item = data.data
                        this.wxQrCode = urlToQRCode(this.item.hdPlayUrl)
                        this.setLoading(false)
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            ...mapActions([
                'setLoading'
            ])
        },
        filters: {},
        watch: {},
        computed: {
            ...mapGetters([
                'loading'
            ])
        },
        components: {

        }
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/mixin";
    .vliveInfo {
        .info-box {
            .tips_box {
                background-color: #F5F7FA;
                padding: 12px 20px;
                &>p {
                    line-height: 24px;
                    span {
                        color: #409EFF;
                    }
                    span:nth-of-type(1) {
                        margin-left: 20px;
                    }
                    .span_cursor:hover {
                        cursor: pointer;
                        color: rgb(17, 130, 243);
                    }
                }
            }
            .step-list {
                @include flexBox(space-between);
                border-right: 1px solid $line;
                border-left: 1px solid $line;
                .step {
                    border-top: 1px solid $line;
                    border-bottom: 1px solid $line;
                    flex-grow: 1;
                    @include flexBox(space-between);
                    .title {
                        flex-grow: 1;
                        height: 40px;
                        line-height: 40px;
                        text-align: center;
                        color: $tcolor-grey;
                        background: $bgcolor-white;
                    }
                    .pentagon {
                        width: 0;
                        height: 0;
                        border-left: 10px solid $line;
                        border-bottom: 20px solid transparent;
                        border-top: 20px solid transparent;
                        position: relative;
                        span {
                            display: block;
                            width: 0;
                            height: 0;
                            border-left: 9px solid $bgcolor-white;
                            border-bottom: 19px solid transparent;
                            border-top: 19px solid transparent;
                            position: absolute;
                            left: -10px;
                            top: -19px;
                        }
                    }
                }
                .is-active .title {
                    background: $bgcolor-base;
                    color: $tcolor-white;
                }
                .is-active .pentagon {
                    span {
                        border-left-color: $bgcolor-base;
                    }
                }
            }
            .step-content {
                box-sizing: border-box;
                height: 134px;
                border: 1px solid $line;
                .plug-flow-list {
                    @include flexBox(space-between);
                    line-height: 46px;
                    flex-grow: 1;
                    overflow: hidden;
                    .box {
                        padding: 20px;
                        flex-grow: 1;
                    }
                    .plug-flow-info {
                        @include flexBox(space-between);
                        .name {
                            width: 160px;
                            flex-grow: 0;
                        }
                        .value {
                            flex-grow: 1;
                            input{
                                width: 100%;
                                height: 36px;
                                padding: 0 5px;
                                box-sizing: border-box;
                                border: 1px solid $line;
                                border-radius: 5px;
                            }
                        }
                        .btn {
                            flex-grow: 0;
                            margin-right: 220px;
                        }
                    }
                }
                .plug-flow-status {
                    width: 250px;
                    text-align: center;
                }
                .step-content-1 {
                    @include flexBox(space-between);
                    .status {
                        height: 60px;
                        border-left: 2px solid $line;
                        line-height: 60px;
                    }
                }
                .step-content-2 {
                    @include flexBox(space-between);
                    .status {
                        height: 60px;
                        border-left: 2px solid $line;
                        line-height: 60px;
                    }
                    .slide-btn {
                        width: 30px;
                        background: $bgcolor-lightgrey;
                        height: 132px;
                        line-height: 132px;
                        text-align: center;
                        color: $tcolor-grey;
                    }
                    .normal {
                        .icon {
                            width: 40px;
                            height: 34px;
                            margin-right: 10px;
                        }
                        .name {
                            width: 250px;
                            flex-grow: 1;
                        }
                        .value {
                            flex-grow: 1;
                            @include flexBox(flex-start);
                        }
                    }
                    .abnormal {
                        .icon {
                            width: 88px;
                            height: 70px;
                        }
                        .name {
                            width: 250px;
                            text-align: center;
                            flex-grow: 0;
                            div {
                                height: 30px;
                                line-height: 30px;
                            }
                        }
                        .value {
                            flex-grow: 1;
                            @include flexBox(center);

                        }
                    }
                }
                .step-content-3 {
                    @include flexBox(center);
                    margin-top: 60px;
                }
            }
            .sel {
                background: $bgcolor-base;
            }
        }
    }
</style>
